<template>
  <panel title="Plan roczny">
    <div slot="toolbar" class="form-group">
      <w-select class="d-inline-block mr-2" :model="$schema.year" :values="years" />

      <w-button class="btn-primary mb-2" text="Pokaż" @click="setYear(model.year)" />
    </div>

    <csv-table :csv="plan" />
  </panel>
</template>

<script>
import { mapState } from 'vuex';

import CsvTable from '@/components/csvTable/CsvTable';
import Panel from '@/components/panel/Panel';
import { formMixin } from '@/mixins/form';
import schema from '@/schemas/plan.schema';
import { config } from '@/utils/config';
import { tryParseInt } from '@/utils/number';
import { getPlan } from '@/utils/plan';

// @vuese
// Plan roczny
// @group Procedure
export default {
  components: { CsvTable, Panel },
  mixins: [formMixin],
  schema,
  data() {
    return { model: { year: this.getYear() }, years: this.getYears() };
  },
  computed: mapState({
    plan: state => state.procedure.plan
  }),
  methods: {
    // @vuese
    // Ustawia rok na który ma być wydany plan
    setYear(year) {
      this.$router.push({ query: { ...this.$route.query, year } });
    },
    // @vuese
    // Aktualnie wybrany rok
    getYear() {
      const september = 8;
      const year = tryParseInt(this.$route.query.year);
      if (year) {
        return year;
      }

      if (new Date().getMonth() < september) {
        return new Date().getFullYear() - 1;
      }

      return new Date().getFullYear();
    },

    // @vuese
    // Lista dostępnych lat
    getYears() {
      const currentYear = new Date().getFullYear();
      return new Array(currentYear - config.startYear + 1)
        .fill(0)
        .map((_, index) => currentYear - index)
        .map(year => ({ value: year, text: `${year.toString()}/${(year + 1).toString()}` }));
    }
  },
  beforeRouteUpdate(to, from, next) {
    getPlan(to, next);
  }
};
</script>
